export const tabChange = tab => ({
  type: "TAB",
  tab
});
export const sidebarExpand = isExpand => ({
  type: "SIDEBAR",
  isExpand
});
export const isHome = isHome => ({
  type: "HOME",
  isHome
});
export const hasInternet = internet => ({
  type: "INTERNET",
  internet
});
export const socketManager = socket => ({
  type: "SOCKET",
  socket
});
export const pageTitle = title => ({
  type: "TITLE",
  title
});
export const pagesize = style => ({
  type: "STYLE",
  style
});
export const appName = (title,subtitle) => ({
  type: "NAME",
  title,
  subtitle
});
